import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';


import {
  AuthGuard,
  redirectLoggedInTo,
  redirectUnauthorizedTo,
} from '@angular/fire/auth-guard';
import { CanActivateGuard } from './guards/can-activate.guard';


const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['']);
const redirectLoggedInToHome = () => redirectLoggedInTo(['home']);



const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule),
    canActivate: [AuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin }
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule),
    canActivate: [AuthGuard],
    data: { authGuardPipe: redirectLoggedInToHome },
  },
  {
    path: 'reportes',
    loadChildren: () => import('./admin/reportes/reportes.module').then(m => m.ReportesPageModule),
    canActivate: [CanActivateGuard]
  },
  {
    path: 'usuarios',
    loadChildren: () => import('./admin/usuarios/usuarios.module').then(m => m.UsuariosPageModule),
    canActivate: [CanActivateGuard]
  },
  {
    path: 'precios',
    loadChildren: () => import('./baseprecios/baseprecios.module').then(m => m.BasepreciosPageModule),
    canActivate: [CanActivateGuard]
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardPageModule),
    canActivate: [CanActivateGuard]
  },
  {
    path: 'informe',
    loadChildren: () => import('./admin/informe-precio/informe-precio.module').then(m => m.InformePrecioPageModule),
    canActivate: [CanActivateGuard]
  },
  {
    path: 'gestionar',
    loadChildren: () => import('./admin/gestionar/gestionar.module').then(m => m.GestionarPageModule),
    canActivate: [CanActivateGuard]
  },
  {
    path: '**',
    redirectTo: 'login',
    pathMatch: 'full'
  }





];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
